import Req from '../../$axios';

const serviceModule = {
  // 获取业务板块
  getProjectFolderList(params) {
    return Req(
      {
        url: 'projectlist/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: false
      },
      params
    )
  },
  // 添加业务板块
  addProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/addprojectlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑业务板块
  updateProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/updateprojectlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除
  deleteProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/deleteprojectlist/',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新部门下业务板块信息
  updateDepartmentProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/updatedepartmentlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取部门下业务板块
  getDepartmentProjectFolderList(params) {
    return Req(
      {
        url: 'projectlist/getdepartmentlist/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新部门下业务板块排序:
  updateDepartmentProjectFolderOrderby(params) {
    return Req(
      {
        url: 'projectlist/updatedepartmentlistorderby/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
}

export default {
  ...serviceModule
};
